/* global window */

export const STARTER_PRESENTATION_PATH = "./templates/GriddExampleSlides.pptx";
export const STARTER_PRESENTATION_URL = "https://docsend.com/view/5cyvzk3ersihj6rw";
export const TUTORIAL_URL = `${window.location.origin}/tutorial.html?source=addin`;

export const STARTER_PRESENTATION_FILENAME = "GriddExampleSlides.pptx";
